import { render, staticRenderFns } from "./UnlinkDevices.vue?vue&type=template&id=6847d0ca&"
import script from "./UnlinkDevices.vue?vue&type=script&lang=js&"
export * from "./UnlinkDevices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src414009122/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6847d0ca')) {
      api.createRecord('6847d0ca', component.options)
    } else {
      api.reload('6847d0ca', component.options)
    }
    module.hot.accept("./UnlinkDevices.vue?vue&type=template&id=6847d0ca&", function () {
      api.rerender('6847d0ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Profile/ClientDevices/UnlinkDevices.vue"
export default component.exports